module.exports = __webpack_public_path__ + "static/img/3.45a2bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/3.png
// module id = 350
// module chunks = 0